module.exports = __webpack_public_path__ + "img/blog-icon.ce4fcb94.png";